export const SBBuild = {
  app: 'login-rest-crl',
  major: 3775,
  minor: 7,
  changelist: 77091,
  compileTime: '2023-11-03T00:59:12Z',
};
